// Attendee Number Stepper Component
class AttendeeStepper {
  constructor() {
    this.decreaseBtn = document.getElementById('decrease-attendees');
    this.increaseBtn = document.getElementById('increase-attendees');
    this.input = document.querySelector('input[name="event_booking[amount]"]');
    this.attendeeLabel = document.getElementById('attendee-label');
    this.attendeeCountElements = document.querySelectorAll('.attendee-count');

    if (!this.decreaseBtn || !this.increaseBtn || !this.input) {
      return;
    }

    this.min = parseInt(this.input.getAttribute('min')) || 1;
    this.max = parseInt(this.input.getAttribute('max')) || 20; // Fallback to 20
    this.current = parseInt(this.input.value) || 1;

    this.init();
  }

  init() {
    // Set initial state
    this.updateInput();
    this.updateButtons();
    this.updateAttendeeLabel();

    // Add event listeners
    this.decreaseBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.decrease();
    });

    this.increaseBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.increase();
    });

    // Handle keyboard navigation
    this.decreaseBtn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.decrease();
      }
    });

    this.increaseBtn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.increase();
      }
    });

    // Prevent manual input since it's readonly
    this.input.addEventListener('keydown', (e) => {
      e.preventDefault();
    });
  }

  decrease() {
    if (this.current > this.min) {
      this.current--;
      this.updateInput();
      this.updateButtons();
      this.updateAttendeeLabel();
      this.triggerPriceUpdate();
    }
  }

  increase() {
    if (this.current < this.max) {
      this.current++;
      this.updateInput();
      this.updateButtons();
      this.updateAttendeeLabel();
      this.triggerPriceUpdate();
    }
  }

  updateInput() {
    this.input.value = this.current;
  }

  updateButtons() {
    // Update decrease button
    if (this.current <= this.min) {
      this.decreaseBtn.disabled = true;
    } else {
      this.decreaseBtn.disabled = false;
    }

    // Update increase button
    if (this.current >= this.max) {
      this.increaseBtn.disabled = true;
    } else {
      this.increaseBtn.disabled = false;
    }
  }

  updateAttendeeLabel() {
    // Update all visible count elements
    this.attendeeCountElements.forEach(element => {
      element.textContent = this.current;
    });

    // Both forms come from the server so they follow the request locale.
    if (this.attendeeLabel) {
      const { labelSingular, labelPlural } = this.attendeeLabel.dataset;
      const label = this.current === 1 ? labelSingular : labelPlural;
      if (label) this.attendeeLabel.textContent = label;
    }
  }

  triggerPriceUpdate() {
    // Trigger the existing price update mechanism
    if (window.updateEventBookingPrices) {
      window.updateEventBookingPrices();
    }

    // Also trigger any existing change handlers on the input
    const changeEvent = new Event('change', { bubbles: true });
    this.input.dispatchEvent(changeEvent);

    const inputEvent = new Event('input', { bubbles: true });
    this.input.dispatchEvent(inputEvent);
  }
}

// Initialize on turbo:load (works with Turbo/Hotwire navigation)
document.addEventListener('turbo:load', function() {
  new AttendeeStepper();
});

// Export for module usage
if (typeof module !== 'undefined' && module.exports) {
  module.exports = AttendeeStepper;
}
